import { Button, Image, Menu } from 'antd'
import React, { useState, useEffect } from 'react'
import logo from "../../../Assets/blueLogo.png"
import { utility } from '../../../Utility'
import { CiLogout } from "react-icons/ci";
import { MdSpaceDashboard } from "react-icons/md";
import { IoChatbubblesOutline } from "react-icons/io5";

export function getItem(id, label, key, icon, children, type) {
    return { id, label, key, icon, children, type };
}

const Sidebar = ({ path = window.location.pathname }) => {
    const [selectedKey, setSelectedKey] = useState(path);

    useEffect(() => {
        setSelectedKey(path);
    }, [path]);

    const handleMenuClick = ({ key }) => {
        setSelectedKey(key);
        utility.navigate(key);
    };

    return (
        <div className='flex flex-col justify-between w-[180px] h-screen overflow-auto no-scroll border-r border-slate-200'>
            <div className='flex justify-center  h-[60px] py-4'>
                <Image src={logo} width={120} className="" preview={false} />
            </div>

            <div className='flex flex-col justify-between gap-3 h-full pb-3 '>
                <div className='flex flex-col h-[68vh] item-center gap-5 mt-10 sidebar-mo ml-3 '>
                    <Menu
                        onClick={handleMenuClick}
                        className='menuListing'
                        selectedKeys={[selectedKey]}
                        mode="inline"
                        items={[
                            getItem("0", "Dashboard", '/dashboard', <MdSpaceDashboard />),
                            getItem("1", "Chat", "/chat", <IoChatbubblesOutline />),
                            getItem("2", "Invoice", "/invoice", <IoChatbubblesOutline />)
                        ]}
                    />
                </div>
            </div>
            <div className='flex items-center justify-center pb-2'>
                <Button
                    onClick={() => {
                        utility.navigate("/")
                        localStorage.clear()
                    }}
                    className='shadow-none border-none text-[10px] p-2 text-custom-error-400 font-medium w-[90%] flex items-center gap-3 bg-blue-950 text-white'>
                    Logout
                </Button>
            </div>
        </div>
    )
}

export default Sidebar
